import { render } from "./IconCommandLink.vue?vue&type=template&id=bb505432&ts=true"
import script from "./IconCommandLink.vue?vue&type=script&lang=ts"
export * from "./IconCommandLink.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__